import { useCallback } from 'react';
import uuid from 'uuid/v1';
import { ENTITY_TYPE, LOGICAL_OPERATOR } from 'modules/push-api/utils/subscriptionConsts';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

const newEntity = {
    id: uuid(),
    type: ENTITY_TYPE.CAMPAIGN,
    endpointUrl: '',
    logicalOperator: LOGICAL_OPERATOR.AND,
    fetchEntity: false,
    fields: [],
};

export const useEntities = () => {
    const { value: entities, onChange: setEntities } = useFormFieldValue({ field: 'entities' });

    const addEntity = () => {
        setEntities([...entities, newEntity]);
    };

    const deleteEntity = useCallback(
        index => {
            const updatedEntities = entities.filter((_, i) => i !== index);
            setEntities(updatedEntities);
        },
        [entities, setEntities]
    );

    const updateEntity = (index, updates) => {
        const updatedEntities = [...entities];
        updatedEntities[index] = { ...entities[index], ...updates };
        setEntities(updatedEntities);
    };

    return {
        entities,
        setEntities,
        addEntity,
        deleteEntity,
        updateEntity,
    };
};
